export default __webpack_public_path__ + "static/media/Gemini_Generated_Image_fbnft2fbnft2fbnf.6ce34dd5.svg";